// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentBlock_root__WcLWC","padding":"ContentBlock_padding__DMnVE"};